import posthog from "posthog-js";

import { pushFaroEvent } from "./faro.service";

const VITE_ENVIRONMENT = import.meta.env.VITE_ENVIRONMENT;
const VITE_POSTHOG_API_KEY = import.meta.env.VITE_POSTHOG_API_KEY;

const trackingEnabled = VITE_ENVIRONMENT === "production";

function isPublicDashboardRoute(): boolean {
  if (typeof window === "undefined") {
    return false;
  }
  return window.location.pathname.startsWith("/embed/");
}

const isPublicDashboard = isPublicDashboardRoute();

if (VITE_POSTHOG_API_KEY && !isPublicDashboard) {
  // Public-dashboard embed routes are served cookieless by the Astro pod, which
  // owns its own view analytics (see the public-dashboard pod). The shared
  // app instance must not init here, or it would emit product events / session
  // replay on a page that never obtained cookie consent.
  posthog.init(VITE_POSTHOG_API_KEY, {
    api_host: "https://eu.posthog.com",
    // Disable canvas snapshotting in session replay. The inventory datagrid is
    // canvas-based (glide-data-grid); rrweb snapshots each redraw as image/png,
    // which floods the network panel and inflates session-replay payloads.
    // DOM session replay still works.
    session_recording: {
      captureCanvas: { recordCanvas: false },
    },
  });
}

export const posthogService = posthog;

export function trackEvent(event: string, properties?: Record<string, unknown>) {
  if (isPublicDashboardRoute()) {
    // Same consent posture as PostHog on embeds: no per-visitor product events
    // reach either analytics sink (Faro session ids are non-persistent, but a
    // sessionStorage identifier is still enough to fall under GDPR consent).
    return;
  }
  // Mirror product events into Grafana (Faro) so user actions correlate with
  // errors and traces. Faro is a no-op unless its collector URL is configured,
  // so this stays inert in dev unless VITE_FARO_COLLECTOR_URL is set.
  pushFaroEvent(event, properties);
  if (!trackingEnabled) {
    return;
  }
  posthog.capture(event, properties);
}
